export default {
    appTitle: 'Web de prestadores',
    backLabel: 'Volte',
    title: 'Verificação em duas etapas ativada',
    body: {
        message: 'Uma mensagem de verificação foi enviada para o endereço de e-mail <strong>{email}</strong> para confirmar o login seguro. <br><br> Procure na mensagem o link <strong>Insira minha conta</strong> para continuar.',
        buttonResend: 'Reenviar',
        buttonResendTimer: 'Tente novamente em {timer} minutos.',
        disclaimer: 'Este processo pode demorar alguns minutos. <br>Se você não receber, verifique sua pasta de spam ou tente novamente',
    },
    errors: {
        invalidLink: 'Este link não está mais disponível',
    },
    ResendLinkMessages: {
        success: 'A mensagem de verificação foi reenviada com sucesso.',
        error: 'A mensagem de verificação não pôde ser reenviada.',
    },

    SmsVerification:{
        title:'Insira o código de verificação:',
        sendTo:'Enviado para:',
        resendTime:'Reenviar código em {timer}.',
        buttonResend:'Reenviar código',
        verifyButton:'Verificar OTP',
        backToLogin:'Voltar para o login',
        success:'Código de verificação correto',
        errors:{
          codeFail:'Código de verificação incorreto, tente novamente.',
          manyAttempts:'Você excedeu o número de tentativas de verificação. Aguarde {timer} para tentar novamente.',
        },
      }
}